import React from 'react';
import PropTypes from 'prop-types';
import { ExternalTypes } from 'constants/accessDevice';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const DeviceExternalTypeSelect = ({
  label,
  variant = 'standard',
  field: { name = 'extenal_type', value },
  form: { errors, touched, setFieldValue = () => {} },
  omitFields = [],
  asyncErrors,
  margin = 'none',
  required = false,
  disabled = false,
  firstLoad = false,
}) => {
  const filterOptions = generateFilterOptions('start', 'label');
  const externalTypes = ExternalTypes();

  return (
    <Autocomplete
      id={name}
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      required={required}
      disabled={disabled}
      firstLoad={firstLoad}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option?.label || ''}
      error={handleError(name, errors, touched, asyncErrors)}
      options={externalTypes.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option == value || ''}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      value={externalTypes.find((status) => status?.value == value) || ''}
    />
  );
};

DeviceExternalTypeSelect.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.string,
  omitFields: PropTypes.object,
  asyncErrors: PropTypes.object,
  margin: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  firstLoad: PropTypes.bool,
};

export { DeviceExternalTypeSelect };
